import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import LavvaDetailsWrapper from '../../../../../components/details-wrapper';
import { useChannelsStateStore } from '../../../store/channels-state';
import { ChannelSensorStateType, ChannelSensorType, ChannelType } from '../../../types';
import { SensorDetailsItem } from '../components/sensor-details-item';

type ChannelDetailsSensorProps = {
  channel: ChannelType;
};

const ChannelDetailsSensor: React.FC<ChannelDetailsSensorProps> = ({ channel }) => {
  const { t: td } = useTranslation('channel-details');
  const state = useChannelsStateStore((s) => s.channelState[channel.id]) as ChannelSensorStateType | null;
  const value = state?.value;

  const tabs = [{ label: td('currently') }];

  return (
    <LavvaDetailsWrapper preventSwipeEvent tabs={tabs}>
      <div className="p-l-24 p-r-24">
        <SensorDetailsItem channel={channel}>
          <Stack direction="row">
            <Typography sx={{ fontSize: '18px', lineHeight: '24px', fontWeight: 700, marginRight: '4px' }}>
              {value != null ? Number(value.toFixed(2)) : '-'}
            </Typography>
            <Typography sx={{ fontSize: '12px', lineHeight: '16px', fontWeight: 500 }}>
              {(channel.data as ChannelSensorType).unit}
            </Typography>
          </Stack>
        </SensorDetailsItem>
      </div>
    </LavvaDetailsWrapper>
  );
};

export default ChannelDetailsSensor;
